import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon"
import Modal from '@mui/material/Modal';

import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";
import Avatar from '@mui/material/Avatar';

import MenuItem from '@mui/material/MenuItem';


import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import MyDataTable from "components/DataTable";
import PageTitle from "components/PageTitle";
import tableData from "DBTables/operai-commesse.json"
import { UPLOAD_PATH, STATUS_WORKER } from "constant.js";
import defaultUser from 'assets/images/default-user.png';

import * as ajax from "helpers/ajax";

import { filterEmptyWorkers, workerPriceByWorkType } from "../../helpers/functions";
import { ROLES } from "constant"

export default class AlertOperai extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            refreshKey: 0,
            filteredData: []
        }
    }

    componentDidMount() {
        this.updateFilteredData();
    }

    refreshData = () => {
        // Forza un re-render aggiornando refreshKey
        this.setState({ refreshKey: this.state.refreshKey + 1 }, () => {
            this.updateFilteredData();
        });
    }

    updateFilteredData = () => {
        const workersWithLessThan8Hours = this.filterWorkersWithLessThan8Hours();
        // Then exclude workers with NOTTURNO or STRAORDINARI status
        const filtered = workersWithLessThan8Hours.filter(worker => worker.stato !== "NOTTURNO" && worker.stato !== "STRAORDINARI ");
        this.setState({ 
            filteredData: filtered,
            refreshKey: this.state.refreshKey + 1 
        });
    }

    filterWorkersWithLessThan8Hours = () => {
        if (!global.workers || !global.workers.data) return [];
        
        // Group workers by date and operaio ID, then sum their hours
        const workersByDate = {};
        
        global.workers.data.forEach(worker => {
            if (!worker.operaio || !worker.data) return;
            
            const key = `${worker.data}_${worker.operaio.id}`;
            
            if (!workersByDate[key]) {
                workersByDate[key] = {
                    ...worker,
                    totalHours: 0
                };
            }
            
            workersByDate[key].totalHours += (worker.ore || 0) + (worker.filler || 0);
        });
        
        // Filter workers with less than 8 total hours per day
        return Object.values(workersByDate)
            .filter(worker => worker.totalHours < 8)
            .sort((a, b) => new Date(b.data) - new Date(a.data));
    }

    fixHour = (worker) => {
        // Add confirmation prompt
        if (!window.confirm("Risolvere definitivamente?")) {
            return;
        }

        const missingHours = 8 - worker.totalHours;
        
        // Update global variable
        const workerIndex = global.workers.data.findIndex(w => w.id === worker.id);
        if (workerIndex !== -1) {
            global.workers.data[workerIndex].filler = missingHours;
        }

        // Save to server
        const updateData = {
            data:{filler: missingHours
        }};

        ajax.ajaxPutStrapi(`operai-commesses/${worker.id}`, updateData, (response) => {
            // Notify parent component of the update
            if (this.props.onWorkerUpdate) {
                this.props.onWorkerUpdate();
            }
            this.updateFilteredData();
        });
    }
    
    render() {
        return (
            <MyDataTable
                key={this.state.refreshKey}
                tableData={tableData}
                customData={this.state.filteredData}
                icon={"Personale"}
                customAction={[
                    {
                        icon: "edit",
                        color: "success",
                        function: this.fixHour
                    }
                ]}
            />
        )
    }
}




AlertOperai.defaultProps = {
    onWorkerUpdate: null
}
